module.exports = __webpack_public_path__ + "static/media/Onigashima.0573409c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/tc/Onigashima.png
// module id = 1143
// module chunks = 0